import { TERMS, TERMS_VERSION } from '@mollusk/shared';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

/** The evaluation terms (#170), with an Accept button until accepted. */
export function TermsView({
  needsAcceptance,
  onAccept,
}: {
  needsAcceptance: boolean;
  onAccept: () => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const accept = async () => {
    setBusy(true);
    setError(null);
    try {
      await onAccept();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'could not record acceptance');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 4 }, maxWidth: 760, mx: 'auto' }}>
      <Typography variant="h5" component="h1" gutterBottom>
        {TERMS.title}
      </Typography>
      <Typography sx={{ mb: 2 }}>{TERMS.intro}</Typography>
      <Box component="ol" sx={{ pl: 3, m: 0 }}>
        {TERMS.points.map((p) => (
          <Box component="li" key={p.heading} sx={{ mb: 1.5 }}>
            <Typography component="span" sx={{ fontWeight: 600 }}>
              {p.heading}
            </Typography>{' '}
            <Typography component="span">{p.body}</Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ mt: 2 }}>
        Questions: <Link href={`mailto:${TERMS.contact}`}>{TERMS.contact}</Link>
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        Version {TERMS_VERSION}
      </Typography>
      {error ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      ) : null}
      {needsAcceptance ? (
        <Button variant="contained" sx={{ mt: 3 }} onClick={() => void accept()} disabled={busy}>
          Accept
        </Button>
      ) : (
        <Typography color="text.secondary" sx={{ mt: 3 }}>
          You have accepted these terms.
        </Typography>
      )}
    </Paper>
  );
}
